import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { AiOutlineShoppingCart, AiOutlineShopping, AiOutlineTeam, AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";
import { getUsers, getProducts } from "../services/statisticsService"; // Import API functions

function Shopping() {
    const [userStats, setUserStats] = useState({ total: 0, growth: 0 });
    const [productStats, setProductStats] = useState({ total: 0, growth: 0 });

    useEffect(() => {
        fetchStatistics();
    }, []);

    const fetchStatistics = async () => {
        try {
            // ✅ Fetch Users and Products Data
            const users = await getUsers();
            const products = await getProducts();

            // ✅ Calculate Growth Percentage Compared to Previous Month
            const now = new Date();
            const lastMonth = now.getMonth();
            // console.log(users);
            // console.log(products);
            const lastMonthUsers = users.filter((user) => new Date(user.CreatedAt).getMonth() === lastMonth - 1);
            const thisMonthUsers = users.filter((user) => new Date(user.CreatedAt).getMonth() === lastMonth);

            const lastMonthProducts = products.filter((product) => new Date(product.createdAt).getMonth() === lastMonth - 1);
            const thisMonthProducts = products.filter((product) => new Date(product.createdAt).getMonth() === lastMonth);

            const userGrowth = calculateGrowth(thisMonthUsers.length, lastMonthUsers.length);
            const productGrowth = calculateGrowth(thisMonthProducts.length, lastMonthProducts.length);

            setUserStats({ total: users.length, growth: userGrowth });
            setProductStats({ total: products.length, growth: productGrowth });
        } catch (error) {
            console.error("Error fetching statistics:", error);
        }
    };

    const calculateGrowth = (current, previous) => {
        console.log("calculateGrowth", current, previous);
        if (previous === 0) return current === 0 ? 0 : 100;
        return (((current - previous) / previous) * 100).toFixed(2);
    };

    return (
        <Section>
            {/* ✅ Total Users */}
            <div className="shopping">
                <div className="design">
                    <div className="logo img3">
                        <AiOutlineTeam />
                    </div>
                </div>
                <div className="total">
                    <h6>TOTAL USERS</h6>
                </div>
                <div className="number">
                    <h6>{userStats.total}</h6>
                    {userStats.growth >= 0 ? (
                        <>
                            <AiFillCaretUp className="svg1" />
                            <span className="t1">+{userStats.growth}%</span>
                        </>
                    ) : (
                        <>
                            <AiFillCaretDown className="svg2" />
                            <span className="t2">{userStats.growth}%</span>
                        </>
                    )}
                </div>
            </div>

            {/* ✅ Total Products */}
            <div className="shopping">
                <div className="design">
                    <div className="logo img4">
                        <AiOutlineShopping />
                    </div>
                </div>
                <div className="total">
                    <h6>TOTAL PRODUCTS</h6>
                </div>
                <div className="number">
                    <h6>{productStats.total}</h6>
                    {productStats.growth >= 0 ? (
                        <>
                            <AiFillCaretUp className="svg1" />
                            <span className="t1">+{productStats.growth}%</span>
                        </>
                    ) : (
                        <>
                            <AiFillCaretDown className="svg2" />
                            <span className="t2">{productStats.growth}%</span>
                        </>
                    )}
                </div>
            </div>
        </Section>
    );
}

export default Shopping;

const Section = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  .shopping {
    padding: 0.5rem 0.5rem 0.5rem 0.5rem;
    border-radius: 1rem;
    color: black;
    background-color: #F8F9FE;
    justify-content: space-evenly;
    align-items: center;
    gap: 0.5rem;
    transition: 0.5s ease-in-out;
    &:hover {
      background-color: #D4E0FF;
      color: black;
      svg {
        color: black;
      }
    }
    .design {
        display: flex;
        align-items: center;
        gap: 0.5rem;
          .img1{
                background-color: #668DFF;
            }
            .img2{
                background-color: #FFB2C3;
            }
            .img3{
                background-color: #FFDD00;
            }
            .img4{
                background-color: #030303;
            }
        .logo {
      border-radius: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.8rem;
      svg {
        font-size: 1rem;
        color: white;
      }
    }
    }
    .total {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        justify-content: space-evenly;
        margin-top: 10px;
     h6{
        color: grey; 
     }
    }
    .number {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        justify-content: space-evenly;
        margin-top: 10px;
            .svg1 {
                color: green; 
            }
          .t1{
              color: green; 
          }    
     h6{
        color: black; 
     }
    }
    
  }
  
  `
  ;